export default __webpack_public_path__ + "static/media/cg_birds_view.a7bb5a94.jpg";